import { createActionGroup, props } from '@ngrx/store';

/*
 * Non-Member Module Actions
 */
enum NonMemberModuleActionTypes {
  NAVIGATE_NON_MEMBER = 'Navigate Non Member',
}

export const NonMemberModuleActions = createActionGroup({
  source: 'Non Member Module',
  events: {
    [NonMemberModuleActionTypes.NAVIGATE_NON_MEMBER]: props<{ payload: { consumerId: number } }>(),
  },
});
